import Swiper from 'swiper'
import { Pagination, Navigation, A11y } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

// Disable loop when there aren't enough slides to fill the largest slidesPerView.
function resolveLoop(slides, options) {
	const resolved = { ...options }
	if (resolved.loop) {
		let maxSlidesPerView = Number(resolved.slidesPerView) || 1
		if (resolved.breakpoints) {
			Object.values(resolved.breakpoints).forEach((breakpoint) => {
				const spv = Number(breakpoint?.slidesPerView)
				if (Number.isFinite(spv)) {
					maxSlidesPerView = Math.max(maxSlidesPerView, spv)
				}
			})
		}
		if (slides.length <= maxSlidesPerView) {
			resolved.loop = false
		}
	}
	return resolved
}

// Initialise one swiper scoped to its own root element (multiple per page).
function initSwiper(el, options) {
	const slides = el.querySelectorAll('.swiper-slide')
	if (slides.length <= 1) return null
	return new Swiper(el, resolveLoop(slides, options))
}

document
	.querySelectorAll('.logo-carousel:not([data-swiper-wired])')
	.forEach((el) => {
		el.setAttribute('data-swiper-wired', '')
		const pagination =
			el.querySelector('.logo-carousel-pagination') ||
			el.parentElement?.querySelector('.logo-carousel-pagination')
		initSwiper(el, {
			modules: [Pagination, A11y],
			slidesPerView: 2,
			breakpoints: {
				640: { slidesPerView: 4 },
				768: { slidesPerView: 5 },
			},
			grabCursor: true,
			loop: true,
			speed: 1200,
			pagination: { el: pagination, clickable: true, dynamicBullets: true },
		})
	})

document
	.querySelectorAll('.slider-block:not([data-swiper-wired])')
	.forEach((el) => {
		el.setAttribute('data-swiper-wired', '')
		initSwiper(el, {
			modules: [Navigation, Pagination, A11y],
			direction: 'horizontal',
			navigation: {
				nextEl: [...el.querySelectorAll('.slider-block-next')],
				prevEl: [...el.querySelectorAll('.slider-block-prev')],
			},
			pagination: {
				el: el.querySelector('.slider-block-pagination'),
				clickable: true,
				dynamicBullets: true,
			},
		})
	})

// ** Secondary Sliders (Reusable) **
document.addEventListener('DOMContentLoaded', function () {
	document
		.querySelectorAll(
			'.secondary-slider-1:not([data-swiper-wired]), .secondary-slider-2:not([data-swiper-wired])',
		)
		.forEach((el) => {
			el.setAttribute('data-swiper-wired', '')
			const swiperInstance = initSwiper(el, {
				modules: [Pagination, A11y],
				slidesPerView: 1,
				spaceBetween: 20,
				loop: true,
				pagination: {
					el: el.querySelector('.swiper-pagination'),
					clickable: true,
				},
			})

			if (swiperInstance) {
				el.addEventListener('mouseenter', () => swiperInstance.autoplay?.stop())
				el.addEventListener('mouseleave', () =>
					swiperInstance.autoplay?.start(),
				)
			}
		})
})

/**
 * Stories Slider element
 */
const storiesSliderEl = document.querySelector('.stories-slider')

/**
 * Check if .stories-slider exists
 */
if (storiesSliderEl) {
	/**
	 * Init Stories Slider
	 *
	 * argument: pass .stories-slider element and parameters
	 */
	const storiesSlider = window.createStoriesSlider(storiesSliderEl, {
		/*
		 * Pass Swiper function so it can create swipers with new Swiper()
		 */
		Swiper: Swiper,
		/*
		 * Autoplay duration to switch story every 5 seconds
		 */
		autoplayDuration: 5000,
		/*
		 * We pass here false as initially our stories slider is hidden and we don't need it to autoplay stories while it is hidden
		 */
		enabled: false,
		/*
		 * We can pass callback function that will be called on each slide change with current main slider index (index of user with stories) and current sub slider index (index of user's specific story)
		 */
		onSlidesIndexesChange() {},
		onEnd() {
			// disable on last story ended
			storiesSlider.disable()
			storiesSliderEl.classList.add('stories-slider-out')
		},
	})

	// open specific user's stories on demo app header stories click
	document.querySelectorAll('.stories a').forEach((userEl, userIndex) => {
		userEl.addEventListener('click', (e) => {
			e.preventDefault()
			// add "in" class (used in demo for animated appearance)
			storiesSliderEl.classList.add('stories-slider-in')
			// enable slider (as we passed enabled: false initially)
			storiesSlider.enable()
			// slide to specific user's stories
			storiesSlider.slideTo(userIndex, 0)
		})
	})

	// open specific user's stories on post avatar click
	document.querySelectorAll('.post-avatar').forEach((avatarEl) => {
		const userIndex = parseInt(avatarEl.getAttribute('data-user-index'), 10)
		avatarEl.addEventListener('click', (e) => {
			e.preventDefault()
			// add "in" class (used in demo for animated appearance)
			storiesSliderEl.classList.add('stories-slider-in')
			// enable slider (as we passed enabled: false initially)
			//   storiesSlider.enable();
			// slide to specific user's stories
			storiesSlider.slideTo(userIndex, 0)
		})
	})

	// stories slider close handler
	storiesSliderEl.addEventListener('click', (e) => {
		// if we clicked at "stories-slider-close-button"
		if (e.target.matches('.stories-slider-close-button')) {
			// disable slider as we don't need it autoplay stories while it is hidden
			storiesSlider.disable()
			// add "out" class (used in demo for animated disappearance)
			storiesSliderEl.classList.add('stories-slider-out')
		}
	})

	// when slider became hidden we need to remove "in" and "out" class to return it initial state
	storiesSliderEl.addEventListener('animationend', () => {
		if (storiesSliderEl.classList.contains('stories-slider-out')) {
			storiesSliderEl.classList.remove('stories-slider-in')
			storiesSliderEl.classList.remove('stories-slider-out')
		}
	})
}
